// [init]
import Axios from "axios/index";
import _ from "lodash";
export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        // Utility Navigation
        get_utility_nav({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_utility_nav',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_utility_extend({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_utility_extend',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        update_utility_nav({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    name1st: data.name1st,
                    name2nd: data.name2nd,
                    name3rd: data.name3rd,
                    name4th: data.name4th,
                    postion1: data.postion1,
                    postion2: data.postion2,
                    postion3: data.postion3,
                    faq: data.faq,
                    faq_url: data.faq_url,
                    helper: data.helper,
                    helper_url: data.helper_url,
                    contact: data.contact,
                    contact_url: data.contact_url,
                    our_blog: data.our_blog,
                    our_blog_url: data.our_blog_url,
                    cleaning: data.cleaning,
                    cleaning_url: data.cleaning_url,
                    nanny: data.nanny,
                    nanny_url: data.nanny_url
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_utility_nav',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // How are we differrent
        update_hawdifferent({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    iconPhoto1: data.iconPhoto1,
                    iconPhoto2: data.iconPhoto2,
                    iconPhoto3: data.iconPhoto3,
                    iconPhoto4: data.iconPhoto4,
                    title1: data.title1,
                    title2: data.title2,
                    title3: data.title3,
                    title4: data.title4,
                    description1: data.description1,
                    description2: data.description2,
                    description3: data.description3,
                    description4: data.description4
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_hawdifferent',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_hawdifferent({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_hawdifferent',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // Before And After
        update_before_and_after({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    photoB: data.photoB,
                    photoA: data.photoA,
                    title: data.title,
                    description: data.description
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_before_and_after',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_before_and_after({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_before_and_after',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // 5 Easy Steps
        get_easy_steps({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_easy_steps',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        update_easy_steps({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    icon1: data.icon1,
                    icon2: data.icon2,
                    icon3: data.icon3,
                    icon4: data.icon4,
                    icon5: data.icon5,
                    title1: data.title1,
                    title2: data.title2,
                    title3: data.title3,
                    title4: data.title4,
                    title5: data.title5,
                    description1: data.description1,
                    description2: data.description2,
                    description3: data.description3,
                    description4: data.description4,
                    description5: data.description5
                };
                console.log(postData);
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_easy_steps',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },
        
        // Disclaimer
        update_disclaimer({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    title: data.title,
                    description: data.description,
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_disclaimer',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_disclaimer({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_disclaimer',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // Cancellation Policy 
        update_cancellation_policy({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    iconPhoto: data.icon,
                    title: data.title,
                    description: data.description
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_cancellation_policy',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_cancellation_policy({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_cancellation_policy',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // Why use our cleaning equipments? 
        update_why_u_o_cleaning_equip({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    iconPhoto: data.icon,
                    title: data.title,
                    description: data.description
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_why_u_o_cleaning_equip',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_why_u_o_cleaning_equip({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_why_u_o_cleaning_equip',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // Hero Images
        update_hero_images({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    images: data,
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_hero_images',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_hero_images({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_hero_images',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // FOOTER
        update_footer({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    logo: data.logo,
					copyright: data.copyright,
					phone: data.phone,
					email: data.email,
					address: data.address,
					url_map: data.url_map,
					menu1: data.menu1,
					menu2: data.menu2,
					menu3: data.menu3,
                    menu4: data.menu4,
                    link1: data.link1,
                    link2: data.link2,
                    link3: data.link3,
                    link4: data.link4,
					social_icon1: data.social_icon1,
					social_icon2: data.social_icon2,
					social_icon3: data.social_icon3,
					social_icon4: data.social_icon4,
                    social_icon5: data.social_icon5,
                    social_link1: data.social_link1,
                    social_link2: data.social_link2,
                    social_link3: data.social_link3,
                    social_link4: data.social_link4,
                    social_link5: data.social_link5
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_footer',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_footer({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_footer',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // Join us submitted
        update_join_us_submitted({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    f_title: data.f_title,
                    f_description: data.f_description,
                    title: data.title,
                    content: data.content,
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_join_us_submitted',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_join_us_submitted({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_join_us_submitted',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_join_us_form({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_join_us_form',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // Contact Us
        update_contact_us({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                const postData = {
                    f_title: data.f_title,
                    f_icon: data.f_icon,
                    f_url: data.f_url,
                    title: data.title,
                    content: data.content,
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_contact_us',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_contact_us_submitted({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_contact_us_submitted',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_contact_us_form({ commit, state }) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_contact_us_form',
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        // Pricing Plan Popup
        update_pricing_plan({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                console.log(data);
                const postData = {
                    id: data.id,
                    title: data.title,
                    description: data.description,
                    note: data.note,
                    icon: data.icon,
                    price: data.price,
                    plan_desc: data.plan_desc
                };
                global.axios.request({
                    method: 'post',
                    url: '/cms/update_pricing_plan',
                    data: postData,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },

        get_pricing_plan({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                global.axios.request({
                    method: 'get',
                    url: '/cms/get_pricing_plan/' + data.id,
                    validateStatus: (status) => {
                        return status == 200;
                    }
                }).then(response => {
                    resolve(response);
                }).catch(error => reject(error));
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/custom/controllers/Cms.js